import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import PrivateRoute from '@/components/PrivateRoute'
import HomePage from '@/pages/HomePage'
import VideoAnalysisPage from '@/pages/VideoAnalysisPage'
import HistoryTasksPage from '@/pages/HistoryTasksPage'
import ImageGenerationPage from '@/pages/ImageGenerationPage'
import VideoGenerationPage from '@/pages/VideoGenerationPage'
import BillingPage from '@/pages/BillingPage'
import SettingsPage from '@/pages/SettingsPage'
import AccountInfoPage from '@/pages/AccountInfoPage'
import VideoPage from '@/pages/VideoPage'
import VideoInputPage from '@/pages/VideoInputPage'
import VideoEditPage from '@/pages/VideoEditPage'
import CanvasPage from '@/pages/CanvasPage'
import PlayerTestPage from '@/pages/PlayerTestPage'
import LoginPage from '@/pages/LoginPage'
import SignupPage from '@/pages/SignupPage'
import PasswordResetPage from '@/pages/PasswordResetPage'
import MembershipPage from '@/pages/MembershipPage'
import PaymentSuccessPage from '@/pages/PaymentSuccessPage'
import PaymentFailurePage from '@/pages/PaymentFailurePage'
import GetStartedPage from '@/pages/GetStartedPage'
import FeedbackPage from '@/pages/FeedbackPage'
import PricingPage from '@/pages/PricingPage'
import LandingPage from '@/pages/LandingPage'
import StartPage from '@/pages/StartPage'
import PrivacyPage from '@/pages/PrivacyPage'
import TermsPage from '@/pages/TermsPage'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

function App() {
  const { t } = useTranslation();

  // 动态设置浏览器标签页标题
  useEffect(() => {
    document.title = t('app.title');
  }, [t]);

  return (
    <Routes>
      {/* Public Routes - No Layout */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgot-password" element={<PasswordResetPage />} />
      <Route path="/reset-password" element={<PasswordResetPage />} />
      <Route path="/payment/success" element={<PaymentSuccessPage />} />
      <Route path="/payment/failure" element={<PaymentFailurePage />} />

      {/* Public Route - No Layout */}
      <Route path="/" element={<Navigate to="/start" replace />} />
      <Route path="/index.html" element={<Navigate to="/start" replace />} />
      <Route path="/start" element={<StartPage />} />
      <Route path="/getstarted" element={<GetStartedPage />} />
      <Route path="/landingpage" element={<LandingPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />

      {/* Private Routes - With Layout */}
      <Route element={<Layout />}>
        <Route element={<PrivateRoute />}>
          <Route path="/home" element={<Navigate to="/start" replace />} />
          <Route path="/production/video" element={<VideoPage />} />
          <Route path="/production/video/input" element={<VideoInputPage />} />
          <Route path="/production/canvas" element={<CanvasPage />} />
          <Route path="/production/analysis" element={<VideoAnalysisPage />} />
          <Route path="/history/tasks" element={<HistoryTasksPage />} />
          <Route path="/tools/image" element={<ImageGenerationPage />} />
          <Route path="/tools/video" element={<VideoGenerationPage />} />
          <Route path="/settings/billing" element={<BillingPage />} />
          <Route path="/settings/general" element={<SettingsPage />} />
          <Route path="/account/info1" element={<AccountInfoPage />} />
          <Route path="/account/info2" element={<AccountInfoPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/test/player" element={<PlayerTestPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
        </Route>
      </Route>

      {/* VideoEditPage - With Layout */}
      <Route element={<Layout />}>
        <Route element={<PrivateRoute />}>
          <Route path="/production/video/edit" element={<VideoEditPage />} />
        </Route>
      </Route>
    </Routes>
  )
}

export default App
